import * as React from 'react';

export interface IIntegerInputProps {
    initialValue: number;
    minValue: number;
    maxValue: number;
    hint?: string;
    onValueSet:(value: number) => void;
}

interface IState {
    value: string;
}

export class IntegerInput extends React.Component<IIntegerInputProps, IState> {
    constructor(props: IIntegerInputProps) {
        super(props);

        this.state = {
            value: ''
        };
    }

    public componentDidMount(){
        this.init(this.props);
    }

    public componentWillReceiveProps(nextProps: IIntegerInputProps) {
        if (nextProps.initialValue) {
            this.init(nextProps);
        } 
    }

    private init(props: IIntegerInputProps) {
        if (props.initialValue) {
            this.setState({
                value: props.initialValue.toString()
            });
        }
    }

    private handleSetValue(increment: number = 0) {
        if (this.state.value !== undefined) {
            let numericValue: number = parseInt(this.state.value, 10);
            if (isNaN(numericValue)) {
                numericValue = this.props.minValue;
            }
            numericValue += increment;
            numericValue = Math.min(this.props.maxValue, Math.max(this.props.minValue, numericValue));
            this.setState({value: numericValue.toString()})
            this.props.onValueSet(numericValue);
        }
    }

    private handleDown(): void {
        this.handleSetValue(-1);
    }

    private handleUp(): void {
        this.handleSetValue(1);
    }

    private handleOnkeyDown(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.key.toLocaleLowerCase() === 'enter') {
            this.handleSetValue();
        }
    }

    public render() {
        return (
            <div className="numeric-control" data-tip={this.props.hint}>
                <span>
                    <input type="text"
                        className="numeric-control-element"
                        value={Math.round(+this.state.value)}
                        pattern="[0-9]"
                        onChange={(e) => this.setState({ value: e.target.value })}
                        onFocus={(e) => e.target.select()}
                        onBlur={() => this.handleSetValue()}
                        onKeyDown={(e) => this.handleOnkeyDown(e)}
                    />
                    <div className="arrow-up" onClick={() => this.handleUp()}><i></i></div>
                    <div className="arrow-down" onClick={() => this.handleDown()}><i></i></div>
                </span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/App/shared/components/integer-input.component.tsx